import { LanguageState, LanguageType } from './state'

export const setLanguage = function (state: LanguageState, newLanguage: LanguageType): void {
  state.language = newLanguage
  localStorage.setItem('TRUORA_LANGUAGE', newLanguage)
}
